var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination_box"},[_c('el-pagination',{attrs:{"background":"","current-page":Number(_vm.pageInfo.page),"page-size":Number(_vm.pageInfo.limit),"page-sizes":_vm.pageSizes,"layout":_vm.layout,"total":Number(_vm.pageInfo.total)},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }